import { differenceInCalendarDays, addDays, subDays } from 'date-fns'

const fechas = {
    getEOM(fecha) {
        if (fecha==null) {
            const hoy=new Date()
            fecha=String(hoy.getFullYear())+"-"+String(hoy.getMonth()+1).padStart(2, "0")+"-"+String(hoy.getDate()).padStart(2, "0")
        }
        fecha=fecha.split("-")[0]+"-"+fecha.split("-")[1]+"-31"
        while (!fechas.isValidDate(fecha)) {
            fecha=fecha.split("-")[0]+"-"+fecha.split("-")[1]+"-"+(fecha.split("-")[2]-1)
        }
        return fecha
    },

    getBOM(fecha=null) {
        if (fecha==null) {
            const hoy=new Date()
            fecha=String(hoy.getFullYear())+"-"+String(hoy.getMonth()+1).padStart(2, "0")+"-"+String(hoy.getDate()).padStart(2, "0")
        }
        return fecha.split("-")[0]+"-"+fecha.split("-")[1]+"-01"
    },

    getHoy() {
        const hoy=new Date()
        const fecha=String(hoy.getFullYear())+"-"+String(hoy.getMonth()+1).padStart(2, "0")+"-"+String(hoy.getDate()).padStart(2, "0")
        return fecha
    },

    getDistanciaEntreFechas(fecha1, fecha2) {
        const fechaDiferencia1=new Date(fecha1.substr(0, 4), parseInt(fecha1.substr(5, 2))-1, fecha1.substr(8, 2))
        const fechaDiferencia2=new Date(fecha2.substr(0, 4), parseInt(fecha2.substr(5, 2))-1, fecha2.substr(8, 2))
        return differenceInCalendarDays(fechaDiferencia1, fechaDiferencia2)                    
    },

    isValidDate (dateString) {
        var regEx = /^\d{4}-\d{2}-\d{2}$/;
        if(!dateString.match(regEx)) return false;  // Invalid format
        var d = new Date(dateString);
        var dNum = d.getTime();
        if(!dNum && dNum !== 0) return false; // NaN value, Invalid date
        return d.toISOString().slice(0,10) === dateString;
    },    

    // getSumarDiasFecha (diasASumar, fechaBase)  {
    //     if (fechaBase==null) {
    //         fechaBase=new Date()
    //     }
    //     let operadorDias
    //     if (diasASumar>=0) {
    //         // operadorDias=require("date-fns/addDays")
    //         operadorDias=addDays
    //     } else {
    //         // operadorDias=require("date-fns/subDays")
    //         operadorDias=subDays
    //     }
    //     const result=operadorDias(fechaBase, Math.abs(diasASumar))
    //     return result
    // }, 

    getSumarDiasFecha (diasASumar, fechaBase)  {
        if (fechaBase==null) {
            fechaBase=new Date()
        }
        fechaBase.setDate(fechaBase.getDate() + diasASumar)
        return fechaBase
    }, 

    getSumarDias (diasASumar, fechaBase=null) {
        if (fechaBase==null) {
            fechaBase=new Date()
        } else {
            if (typeof fechaBase=='string') {
                fechaBase=new Date(fechaBase)
            }
        }
     
        fechaBase.setDate(fechaBase.getDate() + diasASumar)
    
        return  this.dateToString(fechaBase)
    },
    

    dateToString (fecha)  {
        const result=String(fecha.getFullYear())+"-"+String(fecha.getMonth()+1).padStart(2, "0")+"-"+String(fecha.getDate()).padStart(2, "0")
        return result
    },

    stringToFormat(fecha) {
        if (fecha) {
            if (fecha.includes("-")) {
                const segmentos=fecha.split("-")
                return segmentos[2]+"-"+segmentos[1]+"-"+segmentos[0]
            } else {
                return fecha.substr(6,2)+"-"+fecha.substr(4,2)+"-"+fecha.substr(0,4)
            }
        } else if (fecha.includes("/")) {
            const segmentos=fecha.split("/")
            return segmentos[2]+"-"+segmentos[1]+"-"+segmentos[0]
        } else {
            return '  /  /  '
        }
    },

    getDistanciaAHora(horaString) {
        // Hora actual
        const ahora = new Date();
        
        // Hora del string (asumimos que el string está en formato "HH:mm")
        const [horas, minutos] = horaString.split(':').map(Number);
        const horaIngresada = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate(), horas, minutos);
        
        // Diferencia en milisegundos
        const diferenciaMs = horaIngresada - ahora;
        
        // Convertir la diferencia a horas
        const diferenciaHoras = diferenciaMs / (1000 * 60 * 60)

        return diferenciaHoras
    }
}

export default fechas